import { collection, doc, getDoc, getDocs } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import { getCollectionData,getDocData } from '@src/packages/utils';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class HolidayRepository {
  constructor() {
    this.holidaysCollection = FSCollections.HOLIDAYS;
    this.organizationCollection = FSCollections.ORGANIZATIONS;
  }

  getHolidaysPath(orgId) {
    return `${this.organizationCollection}/${orgId}/${this.holidaysCollection}`;
  }

  async create(holidayData, organizationId) {
    return safeExecute(async () => {
      const collectionName = this.getHolidaysPath(organizationId);
      const res = await createOperation(collectionName, null, holidayData, 'create');
      return res;
    });
  }

  async update(holidayId, holidayData, organizationId) {
    return safeExecute(async () => {
      const collectionName = this.getHolidaysPath(organizationId);
      const res = await createOperation(collectionName, holidayId, holidayData, 'update');
      return res;
    });
  }

  async delete(holidayId, organizationId) {
    return safeExecute(async () => {
      const collectionName = this.getHolidaysPath(organizationId);
      await createOperation(collectionName, holidayId, null, 'delete');
    });
  }

  async getHolidayById(holidayId, organizationId) {
    return safeExecute(async () => {
      const holidayRef = doc(db, `${this.getHolidaysPath(organizationId)}/${holidayId}`);
      const docSnap = await getDoc(holidayRef);
      const holidayData = getDocData(docSnap);

      return holidayData;
    });
  }

  async getAllHolidays(organizationId) {
    return safeExecute(async () => {
      const holidaysRef = collection(db, this.getHolidaysPath(organizationId));
      const querySnapshot = await getDocs(holidaysRef);
      const holidays = getCollectionData(querySnapshot);

      return holidays;
    });
  }
}

export default HolidayRepository;
